import React from "react";
import {
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
} from "@mui/material";

export default function ModalCardComponent({
  header,
  content,
  footer,
  classes,
}: {
  header: React.ReactNode;
  content?: React.ReactNode;
  footer?: React.ReactNode;
  classes?: string;
}) {
  return (
    <Card className={`make-modal-card ${classes}`}>
      {header && <CardHeader className="make-modal-header" title={header} />}
      {content && (
        <>
          <Divider flexItem />
          <CardContent
            className="make-modal-content"
            sx={{ bgcolor: "grey.50" }}
          >
            {content}
          </CardContent>
        </>
      )}
      {footer && (
        <>
          <Divider />
          <CardActions className="make-modal-footer">{footer}</CardActions>
        </>
      )}
    </Card>
  );
}
